import { Link } from "react-router-dom";
import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { reviews } from "@/mocks/articles";

function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    // Check honeypot
    const honeypotEl = form.querySelector('input[name="website_alt"]') as HTMLInputElement;
    if (honeypotEl && honeypotEl.value.trim() !== "") {
      setSubmitted(true);
      return;
    }

    setSubmitting(true);

    try {
      const body = new URLSearchParams();
      body.append("name", formData.name);
      body.append("email", formData.email);
      body.append("message", formData.message);

      await fetch("https://readdy.ai/api/form/d913jhk6ci2plld1oi7g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
    } catch {
      // still show success even on error per requirements
    }

    setSubmitting(false);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="text-center py-8">
        <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
          <i className="ri-check-line text-2xl text-accent-600"></i>
        </div>
        <h3 className="text-lg font-bold text-foreground-900 mb-2">提交成功!</h3>
        <p className="text-sm text-foreground-500">感谢你的留言，我们会在 1-2 个工作日内回复。</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-readdy-form="">
      {/* Honeypot */}
      <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground-700 mb-1.5">
            姓名 <span className="text-primary-500">*</span>
          </label>
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="你的名字"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-700 mb-1.5">
            邮箱 <span className="text-primary-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
            placeholder="your@email.com"
          />
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-foreground-700 mb-1.5">
          留言内容 <span className="text-primary-500">*</span>
        </label>
        <textarea
          name="message"
          required
          maxLength={500}
          value={formData.message}
          onChange={(e) => setFormData({ ...formData, message: e.target.value })}
          rows={4}
          className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
          placeholder="请描述你的合作需求或爆料内容..."
        />
        <p className="text-xs text-foreground-400 mt-1 text-right">{formData.message.length}/500</p>
      </div>
      <button
        type="submit"
        disabled={submitting}
        className="w-full py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap disabled:opacity-60"
      >
        {submitting ? "发送中..." : "发送消息"}
      </button>
    </form>
  );
}

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "name": "关于51吃瓜网 - 品牌介绍与联系方式",
        "description": "51吃瓜网是一个专注于娱乐八卦资讯的吃瓜爆料平台，实时更新全网热门瓜料，覆盖明星八卦、综艺内幕、影视爆料等频道。",
        "url": "http://csxsjds.cn/about",
        "publisher": {
          "@type": "Organization",
          "name": "51吃瓜网",
          "url": "http://csxsjds.cn/",
          "description": "全网最新最热的吃瓜爆料平台",
          "foundingDate": "2022",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "email": "contact@csxsjds.cn",
            "availableLanguage": "Chinese"
          }
        }
      }) }} />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "51吃瓜网是什么平台？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "51吃瓜网是一个专注于娱乐八卦资讯的吃瓜爆料平台，实时更新全网热门瓜料，覆盖明星八卦、恋情曝光、综艺内幕等吃瓜热点，每日推送独家爆料资讯。"
            }
          },
          {
            "@type": "Question",
            "name": "如何向51吃瓜网投稿爆料？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "你可以通过关于我们页面的联系表单或发送邮件至 contact@csxsjds.cn 进行投稿。我们支持匿名投稿，一经采用稿费从优。"
            }
          },
          {
            "@type": "Question",
            "name": "51吃瓜网的内容是否真实可靠？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "51吃瓜网拥有专业的娱乐记者团队和广泛的信息源网络，所有爆料均经过多方核实后发布。我们坚持真实、客观、及时的报道原则。"
            }
          },
          {
            "@type": "Question",
            "name": "如何联系51吃瓜网进行商务合作？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "商务合作请发送邮件至 contact@csxsjds.cn，或通过关于我们页面的联系表单留言，我们会在1-2个工作日内回复。"
            }
          },
          {
            "@type": "Question",
            "name": "51吃瓜网有哪些内容频道？",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "51吃瓜网设有明星八卦、综艺内幕、影视爆料、商务爆料、音乐圈、网红圈、时尚圈、体育圈等八大频道，全方位覆盖泛娱乐领域的吃瓜资讯。"
            }
          }
        ]
      }) }} />

      {/* Brand Intro Hero */}
      <section className="relative w-full h-[420px] md:h-[520px] flex items-end">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20and%20amber%20luxurious%20background%20with%20soft%20bokeh%20lights%2C%20elegant%20minimal%20aesthetic%2C%20warm%20atmosphere%2C%20no%20text%2C%20artistic%20composition%2C%20cinematic%20depth%20of%20field%2C%20soft%20glowing%20particles&width=1800&height=900&seq=about-hero-bg&orientation=landscape"
            alt="关于51吃瓜网"
            className="w-full h-full object-cover object-center"
            title="关于51吃瓜网 - 品牌介绍"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/30 to-black/40"></div>
        </div>
        <div className="relative w-full max-w-[1280px] mx-auto px-4 md:px-6 pb-12 md:pb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-500/30 text-accent-300 text-xs font-semibold mb-4">
            关于51吃瓜网
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-3">
            最懂你的<span className="text-accent-400">吃瓜爆料</span>平台
          </h1>
          <p className="text-white/60 text-sm md:text-base max-w-xl leading-relaxed">
            2022年成立至今，我们始终专注于为吃瓜群众提供最快、最全、最真实的娱乐八卦资讯。
          </p>
        </div>
      </section>

      {/* Brand Introduction */}
      <section className="py-16">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row gap-12">
            {/* Text */}
            <div className="flex-1 max-w-2xl">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4">
                品牌故事
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-6 leading-snug">
                从一颗吃瓜的心开始
                <br />
                做到全网领先的<span className="text-primary-500">爆料平台</span>
              </h2>
              <div className="space-y-4 text-[15px] text-foreground-600 leading-relaxed">
                <p>
                  51吃瓜网诞生于2022年，最初由一群热爱娱乐八卦的资深媒体人发起。我们发现市面上的娱乐资讯平台要么更新太慢，要么内容同质化严重，真正有深度、有速度的吃瓜平台寥寥无几。
                </p>
                <p>
                  于是我们决定自己做一个——<strong>专注于速度与深度的吃瓜平台</strong>。我们组建了专业的娱记团队，建立了遍布全网的信息源网络，从明星恋情到综艺内幕，从影视爆料到商业动态，每一个瓜我们都力求做到最快、最准、最全。
                </p>
                <p>
                  如今，51吃瓜网日均活跃用户已突破百万，成为全网最具影响力的<strong>娱乐八卦资讯平台</strong>之一。但我们初心未变：做最懂吃瓜群众的爆料平台，让每一个爱八卦的人都能在这里找到自己喜欢的瓜。
                </p>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-6 mt-10 pt-10 border-t border-background-200/70">
                <div>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">100万+</div>
                  <div className="text-xs text-foreground-500 mt-1">日均活跃用户</div>
                </div>
                <div>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">5000+</div>
                  <div className="text-xs text-foreground-500 mt-1">累计独家爆料</div>
                </div>
                <div>
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">8大</div>
                  <div className="text-xs text-foreground-500 mt-1">内容频道覆盖</div>
                </div>
              </div>
            </div>

            {/* Image + Contact Card */}
            <div className="lg:w-[380px] flex-shrink-0">
              <div className="bg-background-100 rounded-2xl p-6 sticky top-24">
                <h3 className="text-lg font-heading font-bold text-foreground-900 mb-5 flex items-center gap-2">
                  <i className="ri-mail-send-line text-primary-500"></i> 联系我们
                </h3>
                <ContactForm />

                <div className="mt-6 pt-6 border-t border-background-200/70">
                  <h4 className="text-sm font-semibold text-foreground-900 mb-3">其他联系方式</h4>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3 text-sm text-foreground-600">
                      <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                        <i className="ri-mail-line text-foreground-500"></i>
                      </div>
                      <span>contact@csxsjds.cn</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm text-foreground-600">
                      <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                        <i className="ri-wechat-line text-foreground-500"></i>
                      </div>
                      <span>csxsjds_official</span>
                    </div>
                    <div className="flex items-center gap-3 text-sm text-foreground-600">
                      <div className="w-8 h-8 rounded-lg bg-background-200 flex items-center justify-center flex-shrink-0">
                        <i className="ri-weibo-line text-foreground-500"></i>
                      </div>
                      <span>@51吃瓜网官方微博</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Review Section */}
      <section className="py-16 bg-background-100">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3">
              口碑评价
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              媒体认可 · 用户信赖
            </h2>
            <p className="text-sm text-foreground-500 mt-1">来自行业媒体和用户的真实评价</p>
          </div>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-4">
            {reviews.map((review) => (
              <div key={review.id} className="break-inside-avoid mb-4">
                <div className="bg-background-50 rounded-xl p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                      <img
                        src={review.avatar}
                        alt={review.username}
                        className="w-full h-full object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-foreground-900">{review.username}</div>
                      <div className="text-xs text-foreground-400">{review.handle}</div>
                    </div>
                    <div className="ml-auto flex items-center gap-0.5">
                      {Array.from({ length: review.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    &ldquo;{review.content}&rdquo;
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20city%20nightscape%20with%20warm%20golden%20lights%2C%20soft%20bokeh%20city%20lights%2C%20elegant%20urban%20atmosphere%2C%20no%20text%2C%20cinematic%20composition%2C%20dark%20luxurious%20background&width=1600&height=600&seq=about-cta-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
        </div>
        <div className="relative max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-white mb-3">
                商务合作 & 爆料通道
              </h2>
              <p className="text-white/60 text-sm md:text-base leading-relaxed max-w-lg">
                广告投放 · 品牌合作 · 独家爆料 · 稿费结算
              </p>
            </div>
            <a
              href="mailto:contact@csxsjds.cn"
              className="inline-flex items-center gap-3 px-6 py-3 rounded-full bg-white text-foreground-900 font-semibold text-sm hover:bg-accent-100 transition-all duration-300 cursor-pointer group whitespace-nowrap"
            >
              联系我们
              <span className="w-8 h-8 rounded-full bg-foreground-900 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                <i className="ri-arrow-right-line text-white text-sm"></i>
              </span>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
